export const METERS_PER_FOOT = 0.3048;
export const METERS_PER_MILE = 1609.344;
export const METERS_PER_KILOMETER = 1000;

export const metersToFeet = (meters: number) => meters / METERS_PER_FOOT;
export const metersToMiles = (meters: number) => meters / METERS_PER_MILE;
export const metersToKilometers = (meters: number) => meters / METERS_PER_KILOMETER;
export const feetToMeters = (feet: number) => feet * METERS_PER_FOOT;
export const milesToMeters = (miles: number) => miles * METERS_PER_MILE;
export const kilometersToMeters = (kms: number) => kms * METERS_PER_KILOMETER;

/**
 * Converts meters to km or mi
 * @param meters Meters value
 * @param metric Use km instead of mi
 * @returns Converted distance
 */
export const getConvertedDistance = (meters: number, metric: boolean) => (metric ? metersToKilometers(meters) : metersToMiles(meters));

export const getMetersFromDistance = (distance: number, metric: boolean) => (metric ? kilometersToMeters(distance) : milesToMeters(distance));

/**
 * Converts meters to ft, if needed
 * @param meters Meters value
 * @param metric Leave as m instead of converting to ft
 * @returns Converted elevation
 */
export const getConvertedElevation = (meters: number, metric: boolean) => (metric ? meters : metersToFeet(meters));
